<template>
  <RadioList
    :items="{ 1: '通常予約', 3: 'ウォークイン' }"
    v-model="customerType"
    :disabledKeys="isBlock ? [1, 3] : disabledKeys"
    class="radio-list"
  />
</template>

<script>
import { mapState } from 'vuex'
import { syncFromGnaviDaicho, syncFromPOS } from '@/resources/reservation/syncTypeMap'
import { isWalkin, isBlock } from '@/resources/reservation/typeMap'
import RadioList from '@/components/atoms/RadioList'

export default {
  name: 'CustomerTypeInput',
  components: {
    RadioList,
  },
  computed: {
    ...mapState({
      type: state => state.reserves.edit.reservation.type || 1,
      syncType: state => state.reserves.edit.reservation.syncType || 0,
    }),
    syncFromCamera() {
      return [17, 20].includes(this.syncType)
    },
    isPOS() {
      return this.syncType > 0 && !!syncFromPOS[this.syncType]
    },
    isBlock() {
      return isBlock(this.type)
    },
    isDisabled() {
      return this.syncType > 0 && !this.syncFromCamera && !this.isPOS && !syncFromGnaviDaicho[this.syncType]
    },
    disabledKeys() {
      return [(this.isPOS || this.syncFromCamera) && 1, this.isDisabled && 3]
    },
    customerType: {
      get() {
        return isWalkin(this.type) ? 3 : 1
      },
      set(type) {
        this.$store.commit('reserves/edit/update', { type })
      },
    },
  },
}
</script>

<style lang="postcss" scoped>
.radio-list {
  grid-auto-columns: 110px;
}
</style>
